<template>
  <v-app>
    <v-container fluid>
      <template v-if="$insertAccess($route.path)">
        <v-row >
          <v-col md="3" cols="12">
            <v-expansion-panels v-model="panel">
              <v-expansion-panel>
                <v-expansion-panel-title
                  color="blue-grey-lighten-4"
                  class="panel-header"
                >
                  Others Info
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-form @submit.prevent="submit" ref="addBundle" id="addBundle">
                    <v-row class="pa-2">
                      <v-col cols="12">
                        <v-autocomplete
                          variant="outlined"
                          density="compact"
                          bg-color="grey-lighten-4"
                          v-model="cutting_id.value.value"
                          :items="cuttingList"
                          :item-title="item => `${item.code} - ${item.po?.code || ''}`"
                          :item-value="item => item.id"
                          :error-messages="cutting_id.errorMessage.value"
                          :disabled="!isEntryMode"
                          @update:model-value="onCuttingChange"
                          autocomplete="off"
                          clearable
                        >
                          <template #label>
                            Cutting <span class="text-red-accent-4">*</span>
                          </template>
                        </v-autocomplete>
  
                        <input
                          v-model="bundle_id.value.value"
                          type="hidden"
                        />
                      </v-col>
                    </v-row>
                  </v-form>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
  
          <v-col md="9" cols="12">
            <v-expansion-panels v-model="panel2">
              <v-expansion-panel>
                <v-expansion-panel-title
                  color="blue-grey-lighten-4"
                  class="panel-header"
                >
                  Bundle Items
                </v-expansion-panel-title>
                <v-expansion-panel-text>
                  <v-form @submit.prevent="submit" ref="addBundle" id="addBundle">
  
                    <!-- Items Table -->
                    <v-row class="pt-2">
                      <v-col cols="12">
                        <v-table
                          density="compact"
                          :loading="loading"
                          fixed-header
                          class="table-dotted-border-bottom"
                        >
                          <thead>
                            <tr>
                              <th class="text-center" style="width: 5%">SL</th>
                              <th class="text-left" style="width: 30%">Color</th>
                              <th class="text-left" style="width: 30%">Size</th>
                              <th class="text-center" style="width: 20%">Quantity</th>
                              <th class="text-center" style="width: 15%">Action</th>
                            </tr>
                          </thead>
                          <tbody>
                            <tr
                              v-for="(item, index) in itemRows"
                              v-if="itemRows.length > 0"
                              :key="index"
                            >
                              <td class="text-center py-1">{{ index + 1 }}</td>
                              <td class="py-1">
                                <v-select
                                  v-model="item.color_id"
                                  :items="colorList"
                                  :item-title="item => item.name"
                                  :item-value="item => item.id"
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  hide-details
                                  :error="!!itemErrors[index]?.color_id"
                                  :error-messages="itemErrors[index]?.color_id"
                                ></v-select>
                              </td>
                              <td class="py-1">
                                <v-select
                                  v-model="item.size_id"
                                  :items="sizeList"
                                  :item-title="item => item.name"
                                  :item-value="item => item.id"
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  hide-details
                                  :error="!!itemErrors[index]?.size_id"
                                  :error-messages="itemErrors[index]?.size_id"
                                ></v-select>
                              </td>
                              <td class="text-center py-1">
                                <v-text-field
                                  v-model.number="item.qty"
                                  type="number"
                                  variant="outlined"
                                  density="compact"
                                  bg-color="grey-lighten-4"
                                  style="width: 100%;"
                                  hide-details
                                  :min="1"
                                  :error="!!itemErrors[index]?.qty"
                                  :error-messages="itemErrors[index]?.qty"
                                ></v-text-field>
                              </td>
                              <td class="text-left py-1">
                                  <v-btn v-if="index != itemRows.length - 1" icon variant="tonal" size="small" color="primary" class="pa-1" @click="removeItemRow(index)">
                                    <v-icon color="red">mdi-close</v-icon>
                                  </v-btn>
  
                                  <v-btn v-if="index == itemRows.length - 1" variant="tonal" icon size="small" color="primary" @click="addItemRow">
                                    <v-icon color="blue">mdi-plus</v-icon>
                                  </v-btn>
                              </td>
                            </tr>
  
                            <tr v-else-if="loading == true">
                              <td colspan="5" class="text-center">
                                <v-skeleton-loader
                                  type="heading"
                                  :loading="loading"
                                />
                              </td>
                            </tr>
  
                            <tr v-else>
                              <td colspan="5" class="text-center text-red">
                                You have no bundle items
                              </td>
                            </tr>
                          </tbody>
                        </v-table>
                      </v-col>
                    </v-row>
                    <!-- Close Items Table -->
  
                    <v-divider></v-divider>
                    <v-card-actions>
                      <v-row class="pt-2">
                        <v-col cols="8"></v-col>
                        <v-col cols="4">
                          <v-layout class="justify-end">
                            <v-btn
    class="bg-grey-darken-1 me-2"
    variant="flat"
    @click="submitForm(0)"
    :loading="loading && submittingStatus === 0"
  >
    Draft
  </v-btn>
  <v-btn
    class="bg-primary"
    variant="flat"
    @click="submitForm(1)"
    :loading="loading && submittingStatus === 1"
  >
    {{ isEntryMode ? "Save" : "Update" }}
  </v-btn>
                          </v-layout>
                        </v-col>
                      </v-row>
                    </v-card-actions>
                  </v-form>
                </v-expansion-panel-text>
              </v-expansion-panel>
            </v-expansion-panels>
          </v-col>
        </v-row>
      </template>
    </v-container>
  </v-app>
</template>

<script>
import { ref, watch } from "vue";
import { useField, useForm } from "vee-validate";
import * as yup from "yup";
import { useStore } from "vuex";
import { useRouter, useRoute } from "vue-router";
import { toast } from "vue3-toastify";

export default {
  name: "BundleCreate",
  
  data() {
    return {
      panel: [0],
      panel2: [0],
    };
  },

  setup() {
    const store = useStore();
    const router = useRouter();
    const route = useRoute();
    const loading = ref(false);
    const submittingStatus = ref(null); // Add this line - tracks which button is being clicked (0 for draft, 1 for save, null for none)
    const isEntryMode = ref(true);
    const itemRows = ref([
      {
        color_id: "",
        size_id: "",
        qty: 0,
      },
    ]);
    const itemErrors = ref({});

    const { handleSubmit, resetForm, setFieldValue } = useForm({
      validationSchema: yup.object({
        cutting_id: yup.number().required().label("Cutting"),
      }),
    });

    const cutting_id = useField("cutting_id");
    const bundle_id = useField("bundle_id");
    const status = useField("status");

    const addItemRow = () => {
      itemRows.value.push({
        color_id: "",
        size_id: "",
        qty: 0,
      });
    };

    const removeItemRow = (index) => {
      if (itemRows.value.length > 1) {
        itemRows.value.splice(index, 1);
        delete itemErrors.value[index];
        // Reindex errors
        const newErrors = {};
        Object.keys(itemErrors.value).forEach((key) => {
          const idx = parseInt(key);
          if (idx > index) {
            newErrors[idx - 1] = itemErrors.value[key];
          } else if (idx < index) {
            newErrors[idx] = itemErrors.value[key];
          }
        });
        itemErrors.value = newErrors;
      }
    };

    const validateItems = () => {
      itemErrors.value = {};
      let isValid = true;

      itemRows.value.forEach((item, index) => {
        const errors = {};
        
        if (!item.color_id) {
          errors.color_id = "Color is required";
          isValid = false;
        }
        
        if (!item.size_id) {
          errors.size_id = "Size is required";
          isValid = false;
        }
        
        if (!item.qty || item.qty <= 0) {
          errors.qty = "Quantity must be greater than 0";
          isValid = false;
        }

        if (Object.keys(errors).length > 0) {
          itemErrors.value[index] = errors;
        }
      });

      return isValid;
    };

    const onCuttingChange = (cuttingId) => {
      // You can load cutting details here if needed
    };

    const goBack = () => {
      router.push("/production/bundles");
    };

    const submitForm = (status) => {
  submittingStatus.value = status; // Track which button was clicked
  setFieldValue('status', status);
  submit();                       
};


    const submit = handleSubmit((values) => {
      if (!validateItems()) {
        toast.error("Please fill all item fields correctly");
        return;
      }

      const payload = {
        cutting_id: values.cutting_id,
        status: values.status,
        items: itemRows.value.map((row) => ({
          color_id: row.color_id,
          size_id: row.size_id,
          qty: parseInt(row.qty) || 0,
        })),
      };

      loading.value = true;
      const id = values.bundle_id;

      if (id) {
        store
          .dispatch("updateProductionBundle", { id, data: payload })
          .then(() => {
            toast.success("Updated Successfully!");
            goBack();
          })
          .catch((err) => {
            toast.error(err.response?.data?.message || "Something went wrong");
          })
          .finally(() => {
            loading.value = false;
            submittingStatus.value = null; // Reset after submission
          });
      } else {
        store
          .dispatch("saveProductionBundle", payload)
          .then(() => {
            toast.success("Created Successfully!");
            goBack();
          })
          .catch((err) => {
            toast.error(err.response?.data?.message || "Something went wrong");
          })
          .finally(() => {
            loading.value = false;
          });
      }
    });

    // Load data for edit mode
    const loadBundleData = (id) => {
      loading.value = true;
      store
        .dispatch("getProductionBundleById", id)
        .then((response) => {
          const data = response.data.data;
          isEntryMode.value = false;
          cutting_id.setValue(data.cutting_id);
          bundle_id.setValue(data.id);

          if (data.items && data.items.length > 0) {
            itemRows.value = data.items.map((item) => ({
              color_id: item.color_id,
              size_id: item.size_id,
              qty: item.qty,
            }));
          }
        })
        .catch((err) => {
          toast.error(err.response?.data?.message || "Failed to load data");
          goBack();
        })
        .finally(() => {
          loading.value = false;
        });
    };

    // Watch route params for edit mode
    watch(
      () => route.params.id,
      (id) => {
        if (id) {
          loadBundleData(id);
        } else {
          isEntryMode.value = true;
          resetForm();
          itemRows.value = [
            {
              color_id: "",
              size_id: "",
              qty: 0,
            },
          ];
        }
      },
      { immediate: true }
    );

    return {
      cutting_id,
      status,
      bundle_id,
      itemRows,
      itemErrors,
      loading,
      submittingStatus,
      isEntryMode,
      addItemRow,
      removeItemRow,
      onCuttingChange,
      goBack,
      submit,
      resetForm,
      submitForm,
    };
  },

  computed: {
    cuttingList() {
      return this.$store.getters.getProductionCuttingList || [];
    },
    colorList() {
      return this.$store.getters.getProductionColorList || [];
    },
    sizeList() {
      return this.$store.getters.getProductionSizeList || [];
    },
  },

  created() {
    // Load required data
    if (this.$store.getters.getProductionCuttingList.length === 0) {
      this.$store.dispatch("getProductionCuttingList");
    }
    if (this.$store.getters.getProductionColorList.length === 0) {
      this.$store.dispatch("getProductionColorList");
    }
    if (this.$store.getters.getProductionSizeList.length === 0) {
      this.$store.dispatch("getProductionSizeList");
    }
  },
};
</script>
